var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconChevronDown = function SvgIconChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2 2 3 3 3-3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
};
export default SvgIconChevronDown;